module.exports = __webpack_public_path__ + "img/tap3.6a25bdee.svg";